import { useContext, useEffect, useState } from "react";
import {
  getCatalogs,
  createCatalogs,
  updateCatalogs,
  deleteCatalogs,
  reactiveCatalogs,
  getCategory,
} from "../services/console/catalogue";
import { AppContext } from "../context";

type UseType = "DATA" | "ACTIONS" | "CATEGORY";
export type ActionType = "CREATE" | "UPDATE" | "DELETE" | "REACTIVE";

const handleCatalogsFunction = (action: ActionType, t: Function) => {
  switch (action) {
    case "CREATE":
      return {
        actionFn: createCatalogs,
        fnMsg: t("Catalogue.protocolsApiCreateLabel"),
      };
    case "UPDATE":
      return {
        actionFn: updateCatalogs,
        fnMsg: t("Catalogue.protocolsApiUpdateLabel"),
      };
    case "DELETE":
      return {
        actionFn: deleteCatalogs,
        fnMsg: t("Catalogue.protocolsApiDeleteLabel"),
      };
    case "REACTIVE":
        return {
          actionFn: reactiveCatalogs,
          fnMsg: t("Catalogue.protocolsApiReactiveLabel"),
      };
    default:
      return {
        actionFn: () => {},
        fnMsg: "",
      };
  }
};

export const useCatalogs = (type: UseType, catalogId?: number) => {
  const { t, toast, setAppState } = useContext(AppContext);
  const [data, setData] = useState<any | null>(null);
  const [reload, setReload] = useState<number>(0);

  const reloadFn = () => {
    setData(null);
    setReload((prev) => prev + 1);
  };

  const catalogsAction = async (action: ActionType, data: any) => {
    const { actionFn, fnMsg } = handleCatalogsFunction(action, t);
    setAppState((prev) => ({
      ...prev,
      isLoading: true,
    }));
    const actionStatus = await Promise.resolve(actionFn(data))
      .then((response) => {
        toast.current.replace({
          severity: "success",
          summary: "",
          detail: `${fnMsg.replace('{name}', data?.name)}`,
          life: 3000,
        });
        return "SUCCESS";
      })
      .catch((error) => {
        toast.current.replace({
          severity: "error",
          summary: "",
          detail: error?.response?.data?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
          life: 3000,
        });
        return "ERROR";
      });
    setAppState((prev) => ({
      ...prev,
      isLoading: false,
    }));
    return actionStatus;
  };

  useEffect(() => {
    if (type === "DATA") {
      (async function () {
        await Promise.resolve(getCatalogs())
          .then((response) => {
            setData(response?.data);
          })
          .catch((error) => {
            toast.current.replace({
              severity: "error",
              summary: "",
              detail: error?.response?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
              life: 3000,
            });
          });
      })();
    }
  }, [toast, reload, type, catalogId]);

  useEffect(() => {
    if (type === "CATEGORY") {
      (async function () {
        await Promise.resolve(getCategory())
          .then((response) => {
            setData(response?.data);
          })
          .catch((error) => {
            toast.current.replace({
              severity: "error",
              summary: "",
              detail: error?.response?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
              life: 3000,
            });
          });
      })();
    }
  }, [toast, reload, type]);

  return {
    data,
    catalogsAction,
    reloadFn,
  };
};
